import React, { useEffect, useState } from "react"
import ApiURL from "../../services/ApiURL"
import {
  ListMyActivitiesApi,
  ListUpcomingActivitiesDates,
} from "../../services/CallApi"
import ActivityCard from "./ActivityCard/ActivityCard"
import CarouselZeroState from "../../components/ReusableComponents/CarouselZeroState/CarouselZeroState"
import { useSelector } from "react-redux"
import "./MyActivity.scss"
import MyActivitiesCalendar from "./Calendar/Calendar"
import { parseISO } from "date-fns"

export default function MyActivity() {
  const { defaultGym } = useSelector((state) => state.profile.profileData)
  const [activities, setActivities] = useState(null)
  const [pastDates, setPastDates] = useState([])
  const [upcomingDates, setUpcomingDates] = useState([])

  useEffect(() => {
    if (defaultGym) {
      getMyActivities()
      getUpcomingActivitiesDates()
    }
  }, [defaultGym])

  const getMyActivities = () => {
    const data = {
      limit: 300,
      offset: 0,
      gym_ids: JSON.stringify([defaultGym.gym_id]),
    }
    ListMyActivitiesApi(ApiURL["_listActivities"], data).then((res) => {
      if (res.status) {
        const dates = []
        res.list.map((el) => {
          dates.push(parseISO(el.date))
        })
        setActivities(res.list)
        setPastDates(dates)
      }
    })
  }

  const getUpcomingActivitiesDates = () => {
    const data = {
      limit: 300,
      offset: 0,
      gym_ids: JSON.stringify([defaultGym.gym_id]),
    }
    ListUpcomingActivitiesDates(ApiURL["_listUpcomingActivities"], data).then(
      (res) => {
        if (res.status) {
          const dates = []
          res.list.map((el) => {
            dates.push(parseISO(el))
          })
          setUpcomingDates(dates)
        }
      }
    )
  }

  const activityCardArray = activities ? (
    activities.length ? (
      activities.map((el, index) => {
        return <ActivityCard key={index} activityInfo={el} />
      })
    ) : (
      <CarouselZeroState
        text={"When you complete a workout in Tribe, it will appear here."}
      />
    )
  ) : null

  return (
    <div className="MyActivity">
      <div className="MyActivityLeftContainerParent box-layer1">
        <div className="MyActivityLeftContainer">
          <p className="text-h1">My Past Activities</p>
          <div
            className={
              "Activities" + (!activities || !activities.length ? " empty" : "")
            }
          >
            {activityCardArray}
          </div>
        </div>
      </div>
      <div className="MyActivityRightContainer box-layer1">
        <p className="text-h1">Calendar</p>
        <div>
          <MyActivitiesCalendar
            pastDates={pastDates}
            upcomingDates={upcomingDates}
          />
        </div>
        <div className="pastWorkout"> <div className="circle"></div> - Past Activity</div>
        <div className="todayWorkout"> <div className="circle"></div> - Today's Activity</div>
        <div className="upcomingWorkout"> <div className="circle"></div> - Upcoming Activity</div>
      </div>
    </div>
  )
}
